import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PriceRange from './PriceRange';
import FilterBtn from './FilterCheckbox';

const filterIcon = (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.74149 23.5002C7.03417 22.6707 7.57695 21.9524 8.295 21.4443C9.01305 20.9363 9.87103 20.6634 10.7507 20.6634C11.6303 20.6634 12.4883 20.9363 13.2063 21.4443C13.9244 21.9524 14.4671 22.6707 14.7598 23.5002H29.1673V26.3336H14.7598C14.4671 27.1631 13.9244 27.8814 13.2063 28.3894C12.4883 28.8975 11.6303 29.1704 10.7507 29.1704C9.87103 29.1704 9.01305 28.8975 8.295 28.3894C7.57695 27.8814 7.03417 27.1631 6.74149 26.3336H0.833984V23.5002H6.74149ZM15.2415 13.5836C15.5342 12.754 16.077 12.0357 16.795 11.5277C17.5131 11.0196 18.371 10.7467 19.2507 10.7467C20.1303 10.7467 20.9883 11.0196 21.7063 11.5277C22.4244 12.0357 22.9671 12.754 23.2598 13.5836H29.1673V16.4169H23.2598C22.9671 17.2464 22.4244 17.9647 21.7063 18.4728C20.9883 18.9808 20.1303 19.2537 19.2507 19.2537C18.371 19.2537 17.5131 18.9808 16.795 18.4728C16.077 17.9647 15.5342 17.2464 15.2415 16.4169H0.833984V13.5836H15.2415ZM6.74149 3.66688C7.03417 2.83738 7.57695 2.11908 8.295 1.611C9.01305 1.10292 9.87103 0.830078 10.7507 0.830078C11.6303 0.830078 12.4883 1.10292 13.2063 1.611C13.9244 2.11908 14.4671 2.83738 14.7598 3.66688H29.1673V6.50022H14.7598C14.4671 7.32972 13.9244 8.04802 13.2063 8.5561C12.4883 9.06418 11.6303 9.33702 10.7507 9.33702C9.87103 9.33702 9.01305 9.06418 8.295 8.5561C7.57695 8.04802 7.03417 7.32972 6.74149 6.50022H0.833984V3.66688H6.74149ZM10.7507 6.50022C11.1264 6.50022 11.4867 6.35096 11.7524 6.08528C12.0181 5.81961 12.1673 5.45927 12.1673 5.08355C12.1673 4.70783 12.0181 4.34749 11.7524 4.08182C11.4867 3.81614 11.1264 3.66688 10.7507 3.66688C10.3749 3.66688 10.0146 3.81614 9.74892 4.08182C9.48324 4.34749 9.33399 4.70783 9.33399 5.08355C9.33399 5.45927 9.48324 5.81961 9.74892 6.08528C10.0146 6.35096 10.3749 6.50022 10.7507 6.50022ZM19.2507 16.4169C19.6264 16.4169 19.9867 16.2676 20.2524 16.002C20.5181 15.7363 20.6673 15.3759 20.6673 15.0002C20.6673 14.6245 20.5181 14.2642 20.2524 13.9985C19.9867 13.7328 19.6264 13.5836 19.2507 13.5836C18.8749 13.5836 18.5146 13.7328 18.2489 13.9985C17.9832 14.2642 17.834 14.6245 17.834 15.0002C17.834 15.3759 17.9832 15.7363 18.2489 16.002C18.5146 16.2676 18.8749 16.4169 19.2507 16.4169ZM10.7507 26.3336C11.1264 26.3336 11.4867 26.1843 11.7524 25.9186C12.0181 25.6529 12.1673 25.2926 12.1673 24.9169C12.1673 24.5412 12.0181 24.1808 11.7524 23.9152C11.4867 23.6495 11.1264 23.5002 10.7507 23.5002C10.3749 23.5002 10.0146 23.6495 9.74892 23.9152C9.48324 24.1808 9.33399 24.5412 9.33399 24.9169C9.33399 25.2926 9.48324 25.6529 9.74892 25.9186C10.0146 26.1843 10.3749 26.3336 10.7507 26.3336Z" fill="#FD495C"/>
  </svg>
)

const MobileFilters = ({
    filters, subfilters, icons, currentFilters, currentSubfilters, pricing
  }) => {
  const [showFilters, setShowFilters] = useState(false);
  const {close, filter} = icons
  
  return (
    <div>
      <button type="button" className="filter-btn" onClick={() => setShowFilters(true)}>{filterIcon}</button>

      {showFilters && (
        <div className="filters-fullscreen">
          <div className="filters-fullscreen__top">
            <span>
              <img src={filter} alt="" />
              Filtros
            </span>
        
            <button type="button" onClick={() => setShowFilters(false)}><img src={close} alt="cerrar" /></button>
          </div>

          <form>            
            <div className="filters-fullscreen__filter-area">
              {filters.map((f) => (
                <FilterBtn
                  text={f.name}
                  name='filters[]'
                  value={f.id}
                  current={currentFilters} 
                  key={f.name}
                />
              ))}
            </div>

            {Object.keys(subfilters).map((s) => (
              <div key={s} >
                <p>{s}</p>
                <div className="filters-fullscreen__filter-area">
                  {subfilters[s].map(f => (
                    <FilterBtn
                      text={f.name}
                      name='subfilters[]'
                      value={f.id}
                      current={currentSubfilters} 
                      key={f.name}
                    />
                  ))}
                </div>
              </div >
            ))}

            <PriceRange current={pricing} />

            <button type="submit" >Aplicar</button>
          </form>
        </div>
      )}
    </div>
  );
};

MobileFilters.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.object).isRequired,
  subfilters: PropTypes.object.isRequired,
  icons: PropTypes.objectOf(PropTypes.string).isRequired,
  currentFilters: PropTypes.arrayOf(PropTypes.string),
  currentSubfilters: PropTypes.arrayOf(PropTypes.string),
  pricing: PropTypes.string,
}

export default MobileFilters;
